module.exports = __webpack_public_path__ + "img/failureIcon.12b2196c.png";